<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headeracknow01" class="chapter" epub:type="acknowledgments" id="acknow" role="doc-acknowledgments">
<header id="headeracknow01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span><a class="xref" href="#/wsutvmouterlimits0006#racknow">Acknowledgments</a></h1>
</header>
<p class="pf"><span class="dropcap">I</span>n the late 1960s I’d watch <i>The Outer Limits</i> on Saturday afternoons with my brother Frank. It came on right after <i>Candlepins for Cash</i> and right before <i>Creature Feature</i>, which seemed to make some kind of crazy sense. After the somnambulant rhythms of strikes and spares filmed in close-up slow motion, I liked being jolted by <i>The Outer Limits</i>’ scary opening, monsters, and special effects. It wasn’t until much later that I realized that the series was also about ideas. When I found myself teaching Television History a few years ago, I came back to <i>The Outer Limits</i>—and I especially want to thank two students, Julie Ryu and Mariel Segovia, for sharing my enthusiasm for early television and inspiring me to keep exploring it. Penny Sander, Rufus Seder, Paul Rocklin, Bonnie Waltch and Richard Lewis watched episodes with me, kindly shared their insights, and patiently listened to mine. My thanks also to David Schow who generously shared his time and expertise on <i>The Outer Limits</i>.</p>
<p>Annie Martin and Barry Grant gave me initial encouragement to pursue a project on <i>The Outer Limits</i>, and it has been a pleasure to work with editor Marie Sweetman. Thanks too to Carrie Downes Teefey, Emily Shelton, and Lucas Freeman for their help in seeing the manuscript through to completion. A special nod to Rufus Seder for <span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span>his technical help—he is a magician! I also appreciate the thoughtful suggestions made by Barry Grant and two anonymous reviewers that helped make this a better book.</p>
<p>I am sorry to say goodbye to <i>The Outer Limits’</i> universe. I can’t help but feel there is still much to learn.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmouterlimits-0007.vue?03392b9f